module.exports = __webpack_public_path__ + "static/img/pc-dafault2.e68c44f9.png";